export function buildOpenShiftConsoleUrl(apiUrl: string): string {
  const parsed = new URL(String(apiUrl || '').trim());
  const hostname = parsed.hostname.toLowerCase();

  if (!hostname.startsWith('api.')) {
    throw new Error(`Unsupported OpenShift API hostname: ${hostname}`);
  }

  return `https://console-openshift-console.apps.${hostname.slice(4)}`;
}
